import React from "react";
 
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericGet, genericPost } from "../../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../../Constants";
 
 
import { FaTimes, FaEdit, FaFileExport,FaArrowRight } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
 
 
 


const ListMonthlyAllocations = (props) => {
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);
  const [year, setyear] = useState(null)
  const [month, setmonth] = useState(null)
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const getCurrentYear=()=>{
    return new Date().getFullYear();
  
  }
const [status, setstatus] = useState(10001)
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const onBtnExport = useCallback((params) => {
    var params = {
      columnKeys: [
        "staff_id",
        "staff_name",
        "email",
        "role_name",
        "office_name",
        "contract_start_date",
        "contract_end_date",
        "contract_expires_after",
      ],
      fileName: `EmployeeList-${window.h.get_half_formattedDate()}.csv`,
    };
    gridRef.current.api.exportDataAsCsv(params);
  }, []);

  const get_month_name=(month)=>{

    const date = new Date(year, month-1, 1);   
    const month_name = date.toLocaleString('default', { month: 'long' });
    return month_name;
   }
  useEffect(() => {
     
    return () => {};
  }, []);

  const fetch_data = (_status) => {
    setIsLoading(true);
 

    genericPost(ENDPOINTS.ALL_MONTHLY_ALLOCATIONS, {
      "month": month,
      "year":year??getCurrentYear()
  })
    .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
             
                setRowData(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setIsLoading(false);
        console.log(err);
        
    });
   
  };

  return (
    <div>
      <div className="row">
      <div className="col-md-10">
         
        
          <div className="row">
  <div className="col-md-3"> <h1> Monthly Budget Allocations    </h1></div>
 <div className="col-md-3">
    Month  
    <select name="month"
            className="form-control"
            onChange={(e) => {setmonth(e.target.value)}
               
             
            }
            required={true}
          >
            <option value=''>Select Month </option>
            <option value={1}>January </option>
            <option value={2}>February </option>
            <option value={3}>March </option>
            <option value={4}>April </option>
            <option value={5}>May </option>
            <option value={6}>Jun </option>
            <option value={7}>July </option>

            <option value={8}>August </option>
            <option value={9}>September </option>
            <option value={10}>October </option>
            <option value={11}>November </option>
            <option value={12}>December </option>

          


            
          </select>

</div>
 
<div className="col-md-2">  Year

<select className="form-control" name="year" onChange={(e)=>setyear(e.target.value)}>
  <option value={getCurrentYear()}>{getCurrentYear()}</option>
  <option value={Number(getCurrentYear()-1)}>{Number(getCurrentYear()-1)}</option>

</select>
 
  </div>
  
  <div className="col-md-2"> <br/>
  <button type="submit" className="btn btn-primary" onClick={()=>fetch_data()}>View</button>
    
    </div> </div>
      <hr/>
       
          
        </div>
      </div>
      <center><h2> Monthly budget Allocations for {get_month_name(month)}, {year??getCurrentYear()} </h2></center>
      <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          //   overlayLoadingTemplate={
          //     '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          //   }

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

            {
              headerName: "Staff Code",
              field: "staff_code",
              sortable: true,
              filter: true,
            },
          
            {
              headerName: "Staff Name ",
              field: "staff_name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Email  ",
              field: "email",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Branch ",
              field: "branch",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Role ",
              field: "role_name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Department ",
              field: "department",
              sortable: true,
              filter: true,
            },     {
              headerName: "Amount ",
              field: "amount",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Percentage  ",
              field: "percentage",
              sortable: true,
              filter: true,
              cellStyle: function (params) {
                if (
                  Number(params.node.data.percentage) != 100  
                ) {
                  return { color: "white", backgroundColor: "#E97451" };
                } else {
                  return null;
                }
             
              }
            },
            {
              headerName: "Actions",
              field: "",
              sortable: true,
              filter: true,
              cellRendererFramework: (e) => {
                return (
                  <div>
       

                  <button
                  className="btn btn-primary"
                    onClick={() => {
                
                      history.push({
                        pathname: "/hrm/payroll/create-monthly-allocations",
                        state: { _month: e.data.month,_year:e.data.year,_staff_id:e.data.staff_id },
                      });
                    }}
                  >
                   
                    
                    VIEW  &nbsp;  <FaArrowRight style={{ color: "white", cursor: "pointer" }} />
                  </button></div>

                );
              },
          
            },
          ]}
        ></AgGridReact>
      </div>{" "}
    </div>
  );
};

export default ListMonthlyAllocations;
